import "../styles/swe.css";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";

import {
  getUser,
  meetings,
  meetingReset,
  meetingResetGet,
  getMeetingOpening,
  meetingsOther,
  meetingsOtherGet,
} from "../api";

function User() {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  // Access route parameters using useParams
  const { netID } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    const sessionstoreuser = sessionStorage.getItem("isUser");
    if (sessionstoreuser !== netID) {
      // If not authenticated as admin, redirect to login page
      navigate("/login");
    }
  }, []);
  const handleJoinMeeting = async () => {
    const currentMeetings = user.meetings;
    const currentOtherMeetings = user.otherMeetings;
    const currentMeetingReset = user.meetingReset;
    if (currentMeetingReset === 1) {
      const response = await meetingReset(user.netID, 2);
      if (response.status === 200) {
        const response1 = await meetings(user.netID, currentMeetings + 1);
        if (response1.status === 200) {
          alert("Successfully updated attendance");
        }
      }
    } else if (currentMeetingReset === 3) {
      const response = await meetingReset(user.netID, 2);
      if (response.status === 200) {
        const response1 = await meetingsOther(
          user.netID,
          currentOtherMeetings + 1
        );
        if (response1.status === 200) {
          alert("Successfully updated attendance");
        }
      }
    } else if (currentMeetingReset === 0) {
      alert("No ongoing meeting.");
    } else if (currentMeetingReset === 2) {
      alert("Already signed in");
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        // Retrieve the cached password from sessionStorage
        const cachedPassword = sessionStorage.getItem("cachedPassword");

        // Call the getUser API function with netID and cached password
        const response = await getUser(netID);
        if (!response.data) {
          throw new Error("User not found");
        }
        setUser(response.data); // Set user data from the API response
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching user data:", error);
        setError(error);
        setIsLoading(false);
      }
    };
    fetchUser();
  }, [netID]); // Fetch user data when netID changes
  useEffect(() => {
    const intializeMeetingReset = async () => {
      try {
        const cachedPassword = sessionStorage.getItem("cachedPassword");

        const responseUser = await getUser(netID);
        const userReset = responseUser.data.meetingReset;
        if (responseUser.status === 200) {
          if (userReset === -1) {
            const response = await getMeetingOpening("admin_id");
            if (response.status === 200) {
              const response1 = await meetingReset(
                responseUser.data.netID,
                response.data.meetingOpening
              );
            }
          }
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    intializeMeetingReset();
  });

  return (
    <div>
      <Navbar />
      <div className="swe-backdrop justify-center">
        {isLoading ? (
          <div className="swe-prompt">
            <svg
              className="justify"
              width="20"
              height="20"
              fill="currentColor"
              class="animate-spin"
              viewBox="0 0 1792 1792"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z"></path>
            </svg>
          </div>
        ) : error ? (
          <div className="swe-prompt">
            <p className="text-lg text-center text-swe-red">
              Error: {error.message}
            </p>
          </div>
        ) : user ? (
          <div className="swe-user-card animate-fade self-center max-w-screen-md">
            <div className="flex flex-col items-center mt-10 space-y-6">
              <div className="-mt-32 overflow-hidden swe-circle-icon rounded-full animate-spin-slow">
                <div className="absolute inset-0 bg-gradient-to-r from-swe-purple to-swe-purplelight"></div>
              </div>
              <h1 className="swe-title text-swe-purple text-center">
                {user.firstName} {user.lastName}
              </h1>
              <button
                onClick={handleJoinMeeting}
                className="rounded inline-flex group items-center justify-center px-6 py-3 m-1 cursor-pointer border-b-4 border-l-2 active:border-swe-purplelight active:shadow-none shadow-lg bg-gradient-to-tr from-swe-purplelight to-swe-purplelight border-swe-purple text-white"
              >
                <span className="relative font-bold">Join meeting</span>
              </button>
            </div>
            <div className="swe-box-auto justify-end">
              <div className="w-full flex items-start swe-border p-4 space-x-4">
                <div className="flex flex-col self-end items-center">
                  <p className="text-2xl font-bold text-swe-purple">
                    {user.meetings}
                  </p>
                  <p className="text-sm font-bold text-swe-purple">
                    Meeting Count
                  </p>
                </div>
              </div>
              <p className="swe-subtext">{user.netID}</p>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default User;
